import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomPortafolio
 * @author: Maria F Villoria Posso
 * @version: jdesk_1.01.0006
 **/
class CustomPortafolio extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);

        this.ConsultarP = this.ConsultarP.bind(this);
        this.successConsultarP = this.successConsultarP.bind(this);
        this.setButtonEliminar = this.setButtonEliminar.bind(this);
        this.Eliminar = this.Eliminar.bind(this);
        this.ConfirmDelete = this.ConfirmDelete.bind(this);
        this.successEliminar = this.successEliminar.bind(this);
        this.btn_agregar = this.btn_agregar.bind(this);
        this.ValidarCampos = this.ValidarCampos.bind(this);
        this.successCrearR = this.successCrearR.bind(this);
        this.Cancelar = this.Cancelar.bind(this);
        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.successValidarP = this.successValidarP.bind(this);
        this.limpiarErrores = this.limpiarErrores.bind(this);

        this.gridOptionsTablaPortafolio = Object.assign({}, this.gridOptions);
        this.columna_modificada = "";
        this.filterTextLoweCase = "";
        this.onBtNext2                                             = this.onBtNext2.bind(this);
        this.onBtPrevius2                                          = this.onBtPrevius2.bind(this);
        this.onKeyUpText                                           = this.onKeyUpText.bind(this);
        this.countTotal=0;
        this.filtrosTabla = {};
    }

    initForm() {
        console.log("Formulario CustomPortafolio,  @version: jdesk_1.01.0006, @author: Maria F Villoria Posso");

        this.getField('tablaItemsp').setOnBtnNext(this.onBtNext2);
        this.getField('tablaItemsp').setOnBtnPrevius(this.onBtPrevius2);
        this.getField('tablaItemsp').setKeyUpText(this.onKeyUpText)
        if (this.props.data[0].opcion_sub_seccion === 1) {
            this.getField('nombre_formulario').setValue("PRODUCTOS PERMITIDOS POR SUCURSALES");
            this.getField('cod_sucursal').setVisible(true);
            this.getField('nom_sucursal').setVisible(true);
            this.getField('cod_sucursal').setOnChange((props) => {
                this.getField('consultar').setDisabled(false);
                this.getField('Agregar').setVisible(false);
                this.getField('tablaItemsp').toggle(false);
                this.Cancelar();
            });
            this.getField('consultar').setVisible(true);
            this.getField("consultar").setClick((props) => {
                this.getField('tablaItemsp').countPagination = 1;
                this.countTotal=0;
                this.filtrosTabla={};
                this.columna_modificada = "";
                this.filterTextLoweCase = "";
                this.columna = "";
                this.orden= "";
                this.limpiarErrores();
                this.getField('tablaItemsp').toggle(false);
                this.Cancelar();
                this.ConsultarP();
            });
            this.getField("Agregar").setClick(this.btn_agregar);
            this.getField("Aceptar").setClick(this.ValidarCampos);
            this.getField('Cancelar').setClick(this.Cancelar);
        }

    }

    ConsultarP() {
        if (this.getField('cod_sucursal').valid() && this.getField('nom_sucursal').valid()) {

            let datos={ datos: { } };

            datos.datos={};
            this.getField('consultar').setDisabled(true);
            this.getField('Agregar').setVisible(true);

            if(this.columna !== "" &&  this.orden !== null){
                datos.datos.columna=this.columna;
                datos.datos.orden=this.orden;
            }

            if(Object.keys(this.filtrosTabla).length > 0){
                for (let key in this.filtrosTabla) {
                    if (this.filtrosTabla.hasOwnProperty(key)) {
                        let filtro = this.filtrosTabla[key];
        
                        // Verificamos qué campo es y tomamos el valor del filtro
                        if (key.includes('codigo_articulo')) {
                            datos.datos.codigo_articulo = filtro.dateFrom || filtro.filter;
                            datos.datos.columna2 = "codigo_articulo"
                        }
                        if (key.includes('codigo_usuario')) {
                            datos.datos.codigo_usuario = filtro.filter;
                            datos.datos.columna3 = "codigo_usuario";
                        }
                    }
                }
                datos.datos.id = this.getField('id_sucursal').getValue();
                datos.datos.sql_filter="OFFSET "+(this.countTotal*15)+" LIMIT 15";

                this.generalFormatPmv = { tipo_servicio: 'maes-portafolio', operacion: '1_2', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successConsultarP,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }else{
                datos.datos.id = this.getField('id_sucursal').getValue();
                datos.datos.sql_filter="OFFSET "+(this.countTotal*15)+" LIMIT 15";

                this.generalFormatPmv = { tipo_servicio: 'maes-portafolio', operacion: '1_1', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successConsultarP,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }         
        }
        
    }

    successConsultarP(data) {
        if (data.estado_p === 200) {
            this.getField('tablaItemsp').toggle(true);
            this.getField("tablaItemsp").disabledButtons(false);
            let configCell = new Map();

            configCell.set('eliminar', { cellRenderer: this.setButtonEliminar, width: 110, sortable: false, filter: false, field: 'eliminar' });
            
            const textFilterParams = {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textFormatter: (text) => (text || '').toString().toLowerCase(),
                debounceMs: 200,
                maxNumConditions: 1,
            };

            configCell.set("codigo_articulo", {
                filter: "agTextColumnFilter",
                filterParams: textFilterParams,
                valueGetter: (p) => (p.data?.codigo_articulo != null ? String(p.data.codigo_articulo) : "")
            });

            configCell.set("codigo_usuario", {
                filter: "agTextColumnFilter",
                filterParams: textFilterParams,
                valueGetter: (p) => (p.data?.codigo_usuario != null ? String(p.data.codigo_usuario) : "")
            });

            this.gridOptionsTablaPortafolio.onFilterChanged = (event) => {
                const api = event.api;
                const filterModel = api.getFilterModel();

                this.filtrosTabla = filterModel;
                const colIds = Object.keys(filterModel);

                if (colIds.length > 0 || this.filtrosTabla.length > 0) {
                    const ultimaColumna = colIds[colIds.length - 1];
                    let valorFiltro = filterModel[ultimaColumna]?.filter || filterModel[ultimaColumna]?.dateFrom || "";

                    valorFiltro = (valorFiltro || "").toString().trim();

                    if (this.columna_modificada !== ultimaColumna || this.filterTextLoweCase !== valorFiltro) { 
                        this.getField('tablaItemsp').countPagination = 1;
                        this.countTotal = 0; 
                    }

                    this.columna_modificada = ultimaColumna;
                    this.filterTextLoweCase = valorFiltro;
                    this.columna = "";
                    this.orden= "";
                    this.ConsultarP();
                } else {
                    // No hay filtros activos
                    this.columna_modificada = "";
                    this.filterTextLoweCase = "";
                    this.countTotal = 0; 
                    this.columna = "";
                    this.orden= "";
                    this.getField('tablaItemsp').countPagination = 1;
                    this.ConsultarP();
                }
            };

            
            this.gridOptionsTablaPortafolio.onSortChanged = (event) => {
                let tamaño = event.columns.length;
                this.columna = event.columns[tamaño-1].colId
                this.orden = event.columns[tamaño-1].sort

                if(this.orden !== null){
                    this.countTotal = 0; 
                    this.ConsultarP();
                }else{
                    this.ConsultarP();
                }
            }


            this.gridOptionsTablaPortafolio.enableCellTextSelection = true;

            let totalregistros = 0;

            if (data?.data?.data) {
                totalregistros = data.data.data.length > 0 ? data.data.data[0].full_count : 0;
                this.getField('tablaItemsp').setTtotalPg(0);
            } else if (data?.data) {
                this.getField('tablaItemsp').setTtotalPg(0);
                totalregistros = data.data.length > 0 ? data.data[0].full_count : 0;
            }

            this.getField('tablaItemsp').setTtotalPg(Math.ceil(totalregistros / 15));

            if (this.columna_modificada && this.filterTextLoweCase) {
                this.getField("tablaItemsp").setRowData(data.data.data);
            }else{
                if (data?.data?.data) {
                    this.gridOptionsTablaPortafolio["rowData"] = data.data.data;
                }else{
                    this.gridOptionsTablaPortafolio["rowData"] = data.data;
                }
                this.getField('tablaItemsp').initData(this.gridOptionsTablaPortafolio, configCell);
                this.getField('tablaItemsp').toggle(true);
            }
            
        } else if (data.estado_p === 404) {
            if (this.columna_modificada && this.filterTextLoweCase) {
                this.getField('tablaItemsp').setRowData([]);
                this.getField('tablaItemsp').countPagination = 1;
                this.getField("tablaItemsp").disabledButtons(true);
                let totalregistros = 0;
                this.getField('tablaItemsp').setTtotalPg(Math.ceil(totalregistros / 15));
            }else{
                this.getField('tablaItemsp').toggle(false);
            }
        }
    }

    onBtNext2(){
        this.countTotal++;
        this.getField("tablaItemsp").disabledButtons(true);
        this.ConsultarP();
    }

    onBtPrevius2(){
        this.countTotal--;
        this.getField("tablaItemsp").disabledButtons(true);
        this.ConsultarP();
    }

    onKeyUpText(value){
        this.countTotal = value-1;
        this.getField("tablaItemsp").disabledButtons(true);
        this.ConsultarP();
    }

    setButtonEliminar(props) {
        let id = props.data.id;
        let button = document.createElement("input");
        button.onclick = () => this.Eliminar(id);

        button.setAttribute("id", 'button_delete_' + id);
        button.setAttribute("class", "buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Eliminar");
        return this.createElementJaivana(button);
    }

    Eliminar(id) {
        this.ids = id;
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', '¿Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(this.ConfirmDelete);
        this.getField('confirmModalCustom').toggle(true);
    }

    ConfirmDelete() {
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos: {
                id: this.ids,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'maes-portafolio', operacion: '7', operacion_tipo: "eliminar" };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successEliminar,
                error: this.error_,
                general: this.generalFormatPmv //se envia el generales de arriba
            });
    }


    successEliminar(data) {
        if (data.estado_p === 200) {
            this.limpiarCampos();
            this.ConsultarP();
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'El registro no pudo ser eliminado', "error");
        }

    }

    btn_agregar() {
        this.getField('cod_articulo').setVisible(true);
        this.getField('nom_articulo').setVisible(true);
        this.getField('usuario').setVisible(true);
        this.getField('nom_usuario').setVisible(true);
        this.getField('Aceptar').setVisible(true);
        this.getField('Cancelar').setVisible(true);
    }

    ValidarCampos() {
        if (this.getField('cod_articulo').valid() && this.getField('nom_articulo').valid()
            && this.getField('usuario').valid() && this.getField('nom_usuario').valid()) {
            this.getField('Aceptar').setDisabled(true);
            this.datos = {
                datos: {
                    id_sucursal: this.getField('id_sucursal').getValue(),
                    articulo_id: this.getField('articulo_id').getValue(),
                    usuario_id: this.getField('usuario_id').getValue()
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'maes-portafolio', operacion: 'validarUnico', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: this.datos,
                    success: this.successValidarP,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successValidarP(data) {
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'El código del producto ingresado ya existe para esta sucursal.', 'error');
            this.getField('Aceptar').setDisabled(false);
        } else {
            this.generalFormatPmv = { tipo_servicio: 'maes-portafolio', operacion: '5', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: this.datos,
                    success: this.successCrearR,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successCrearR(data) {
        if (data.estado_p === 200) {
            this.getField('tablaItemsp').countPagination = 1;
            this.countTotal=0;
            this.filtrosTabla={};
            this.columna_modificada = "";
            this.filterTextLoweCase = "";
            this.limpiarCampos();
            this.ConsultarP();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se pudo crear el registro.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
        this.getField('Aceptar').setDisabled(false);
    }

    Cancelar() {
        this.limpiarErrores();
        this.limpiarCampos();
        this.getField('cod_articulo').setVisible(false);
        this.getField('nom_articulo').setVisible(false);
        this.getField('usuario').setVisible(false);
        this.getField('nom_usuario').setVisible(false);
        this.getField('Aceptar').setVisible(false);
        this.getField('Cancelar').setVisible(false);
    }

    limpiarErrores() {
        this.getField('usuario').setError(false, '');
        this.getField('nom_usuario').setError(false, '');
        this.getField('cod_articulo').setError(false, '');
        this.getField('nom_articulo').setError(false, '');
    }

    limpiarCampos() {
        this.getField('articulo_id').setValue('');
        this.getField('usuario_id').setValue('');
        this.getField('usuario').setValue('');
        this.getField('nom_usuario').setValue('');
        this.getField('cod_articulo').setValue('');
        this.getField('nom_articulo').setValue('');
    }


}
FormJaivana.addController("maes-portafolio", CustomPortafolio);
export default CustomPortafolio;